import React, { useState } from 'react';
// import { useHistory } from 'react-router-dom';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { DO_MAIN } from '@/constants/myconstants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';
import PopUp from '@/components/contents/home/PopUp';
import { getLocaleWordContent } from '@/utils/language.util';

function FindId({ show, ModalActions }) {
    const [userid, setUserid] = useState('');
    const [message, setMessage] = useState('');
    // const history = useHistory();

    const handleChange = (e) => {
        if (e) e.preventDefault();
        setUserid(e.target.value);
    };

    const handleSend = (e) => {
        if (e) e.preventDefault();
        _submit_userid(userid);
    };

    // const handleSubmit = (e) => {
    //     if (e) e.preventDefault();
    //     setUserid('');
    //     history.push('/');
    // };

    const _submit_userid = async () => {
        const params = { userid: userid, domain: DO_MAIN };
        const rsp = await request.post('/auth/forgot_password', toFormData(params)).then((response) => response.data);

        if (Number(rsp.ret) === 1) {
            setMessage('등록된 이메일로 임시비밀번호가 발송되었습니다.');
            ModalActions.showMessage({ show: true });
            setUserid('');
            return rsp;
        } else {
            setMessage(rsp.msg);
            ModalActions.showMessage({ show: true });
            return rsp;
        }
    };

    return (
        <>
            {show.show && <PopUp message={message} path={'/'} />}
            <div className="login_inner">
                <h3 className="text-center">{getLocaleWordContent('비밀번호 찾기')}</h3>
            </div>
            <div className="sp40"></div>
            <div className="bg_left">
                <div className="log_box" id="email">
                    <div className="login_inner">
                        <div className="inputbox">
                            <div className="input_form">
                                <input
                                    type="text"
                                    className="input01"
                                    placeholder={getLocaleWordContent('이메일(E-mail)')}
                                    name="email"
                                    defaultValue={userid}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d_flex">
                                <p>{getLocaleWordContent('이메일 임시 비밀번호 전송')}</p>
                                <input type="button" defaultValue={getLocaleWordContent('전송')} className="btn01" onClick={handleSend} />
                            </div>
                            <div className="sp20"></div>
                            <ul className="help_text">
                                <li>{getLocaleWordContent('등록된 이메일로 임시비밀번호가 발송됩니다.')} </li>
                                <li>{getLocaleWordContent('임시비밀번호로 로그인 후 꼭! 사용하실 비밀번호로 변경 후 사용하시기 바랍니다.')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        show: state.widget.getIn(['message', 'show']),
    }),
    (dispatch) => ({
        ModalActions: bindActionCreators(modalActions, dispatch),
    }),
)(FindId);
